import { classnames } from '@/libs/utils';

export const TransitionPropertyOptions = ({
  options,
  onClick,
  selectedValue,
  disabled
}: {
  options: { Icon: any; value: string }[];
  onClick: (value: string) => void;
  selectedValue: string | null;
  disabled?: boolean;
}) => {
  return (
    <div className="flex h-10 w-full gap-0.5 rounded-lg bg-slate-100 p-1">
      {options.map(option => {
        const isActive = selectedValue === option.value;
        return (
          <div
            key={option.value}
            data-testid={`property-option-${option.value}`}
            data-selected={isActive}
            data-disabled={disabled}
            onClick={() => (disabled ? undefined : onClick(option.value))}
            className={classnames(
              'flex flex-1 cursor-pointer items-center justify-center rounded-lg p-2 text-center text-xs hover:bg-white',
              isActive ? 'bg-white shadow-sm' : '',
              disabled ? 'cursor-not-allowed opacity-50' : ''
            )}
          >
            {option.Icon}
          </div>
        );
      })}
    </div>
  );
};
